var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRadar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M14 4.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0ZM20 10.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0ZM16 16.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0ZM1.293 2.293a1 1 0 0 1 1.414 0l9 9a1 1 0 0 1-1.414 1.414l-9-9a1 1 0 0 1 0-1.414Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.35 4.935a1 1 0 0 1-.005 1.414A7.937 7.937 0 0 0 3 12a8 8 0 0 0 8 8 1 1 0 1 1 0 2C5.478 22 1 17.522 1 12a9.937 9.937 0 0 1 2.935-7.07 1 1 0 0 1 1.414.005Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8.872 8.458a1 1 0 0 1 .01 1.414A3.025 3.025 0 0 0 8 12c0 1.658 1.342 3 3 3a1 1 0 1 1 0 2c-2.762 0-5-2.238-5-5 0-1.378.565-2.626 1.458-3.532a1 1 0 0 1 1.414-.01Z",
    clipRule: "evenodd"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadar);
export default __webpack_public_path__ + "static/media/Radar.69a3710a11e198a3b60f830befc5e149.svg";
export { ForwardRef as ReactComponent };